import React from 'react';
import { PreloaderContainer } from './components';

interface PreProps {
  load: boolean;
}

export const PreLoader = ({ load }: PreProps): React.ReactNode => {
  if (!load) return null;
  return (
    <PreloaderContainer
      id={load ? 'preloader' : 'preloader-none'}
      sx={{
        opacity: load ? 1 : 0,
        transition: 'opacity 0.3s ease',
      }}
    />
  );
};
